import React, { Component } from "react";
import axios from 'axios';
import '../contact.css';

export class Contact extends Component {

  constructor(props) {
    super(props);

    // This binding is necessary to make `this` work in the callback
    this.test = this.test.bind(this);
  }

  test(e) {
    // debugger;
    // axios({
    //   method: 'post',
    //   url: '/mail',
    //   data: {
    //     firstName: 'Finn',
    //     lastName: 'Williams'
    //   }
    // });
  }

  render() {
    return (
      <div>
        <div id="contact">
          <div className="container">
            <div className="col-md-8">
              <div className="row">
                <div className="section-title">
                  <h2>Get In Touch</h2>
                  <p>
                    Please fill out the form below to send us an email and we
                    will get back to you as soon as possible.
                  </p>
                </div>
                <form name="sentMessage" id="contactForm" noValidate>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          id="name"
                          className="form-control"
                          placeholder="Name"
                          required="required"
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="email"
                          id="email"
                          className="form-control"
                          placeholder="Email"
                          required="required"
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows="4"
                      placeholder="Message"
                      required
                    ></textarea>
                    <p className="help-block text-danger"></p>
                  </div>
                  <div id="success"></div>
                  <button id="sendMsg" type="submit" className="btn btn-custom btn-lg">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
            <img className="img-responsive" src="./img/new-logo.png" alt="Lesson on golf logo" />
            <div className="col-md-3 col-md-offset-1 contact-info">
              <div className="contact-item">
                <p>
                  <span>
                    <i className="fa fa-envelope-o"></i> Email
                  </span>{" "}
                  lessonongolfdeals@gmail.com
                </p>
              </div>
              <p>
                Links:
              </p>
              <ul>
                <li>
                  <a className="link" target="_blank"
                    rel="noopener noreferrer" href="https://www.carlsgolfland.com/">
                    Carls Golf Land
                  </a>
                </li>
                <li>
                  <a className="link link-youtube" target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.youtube.com/channel/UCcJFuKnfXn8IKKuzUBebE_w">
                    <i className="fa fa-youtube-play"></i> Lesson On Golf YouTube
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-12">
              <div className="row">
                <div className="social">
                  <ul>
                    <li>
                      <a
                        href="https://x.com/JeffLesson"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-x"
                        aria-label="Follow Jeff Lesson on X"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          className="x-logo"
                        >
                          <path
                            fill="currentColor"
                            d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                          />
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.youtube.com/channel/UCcJFuKnfXn8IKKuzUBebE_w"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-youtube"
                        aria-label="Lesson on Golf YouTube channel"
                      >
                        <i className="fa fa-youtube-play"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="row">

              </div>
            </div>
          </div>
        </div>
        <div id="footer">
          <div className="container text-center">
            <p>
              &copy; 2022 Designed by <a target="_blank" rel="noopener noreferrer" href="https://www.protocoding.com">protocoding.com</a>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;
